import { useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function PaymentSuccess() {
  const port = process.env.REACT_APP_SECRET;
  const navigate = useNavigate();

  useEffect(() => {
    const query = new URLSearchParams(window.location.search);
    console.log("Query Parameters:", query.toString());
    const orderID = query.get("token");
    const groupageID = query.get("groupageId");
    if (!orderID) return;
    if (!groupageID) return;

    console.log("groupageID:", groupageID);
    console.log("orderID:", orderID);
    let isCalled = false;

    if (!isCalled) {
      isCalled = true;

      axios
        .post(`${port}/paypal/api/capture-order/${orderID}`)
        // .then((res) => {
        //     navigate("/dashboard/payment");
        // })
        // // if (orderID) {
        // //     axios.post(`${port}/paypal/api/capture-order/${orderID}`)
        // .then(async (res) => {

        //     const capture =
        //         res.data.purchase_units[0].payments.captures[0];

        //     console.log(res);
        //     console.log('this is capture -: ', capture);
        // await axios.post(`${port}/paypal/api/save_transaction`, {
        //     orderId: res.data.id,
        //     transactionId: capture.id,
        //     offerId: localStorage.getItem("offerId"),
        //     amount: capture.amount.value,
        //     status: res.data.status,
        //     paypal_id: res.data.payer.payer_id,
        //     payment_time: capture.create_time,
        // }, {
        //     headers: {
        //         Authorization: localStorage.getItem("token"),
        //     }
        // });

        // navigate("/dashboard/payment");
        .then(async (res) => {
          if (!res || !res.data) {
            console.log("No response data");
            return;
          }

          const capture = res.data.purchase_units?.[0]?.payments?.captures?.[0];

          // console.log("Capture:", capture);

          await axios.post(
            `${port}/paypal/api/save_transaction`,
            {
              orderId: res.data.id,
              transactionId: capture.id,
              offerId: groupageID,
              // offerId: localStorage.getItem("offerId"),
              amount: capture.amount.value,
              status: res.data.status,
              paypal_id: res.data.payer.payer_id,
              payment_time: capture.create_time,
            },
            {
              headers: {
                Authorization: localStorage.getItem("token"),
              },
            },
          );

          await axios.post(
            `${port}/paypal/api/groupage-payment-status/${groupageID}`,
            {
              headers: {
                Authorization: localStorage.getItem("token"),
              },
            },
          );

          navigate("/dashboard/payment");
        })
        .catch((err) => console.log(err));
    }
  }, []);

  return <h3>Processing payment...</h3>;
}

export default PaymentSuccess;
